import { z } from 'zod';
/**
 * Role carried by a Membership (User ↔ Organisation link).
 *
 * - `tenant_admin`: admin of an Organisation (manage members, billing, numbers)
 * - `caller`: operates the dialer for an Organisation
 * - `viewer`: read-only access to an Organisation's results (ex-role `client`)
 *
 * Super admins (Swoft staff) are NOT carried by a Membership. They are
 * identified by the boolean `isSuperAdmin` on the User aggregate.
 *
 * See ADR-018 (phase 1.5 migration).
 */
export const RoleSchema = z.enum(['tenant_admin', 'caller', 'viewer']);
export const ROLE_LABELS = {
    tenant_admin: 'Administrateur',
    caller: 'Utilisateur',
    viewer: 'Observateur',
};
//# sourceMappingURL=role.schema.js.map